/**
 * @voltxampere/ui — AC Voltage Source (AC Kaynak)
 *
 * Circle with a single sine half-period inside, traced as two
 * quadratic Beziers. Top terminal is the live output, bottom is
 * the return. Sprint 25 R3 lane 1 added the pin lead lines so
 * the snap target reads from the viewBox edge — same pattern as
 * `dc-source`.
 *
 * v1 reference: `~/Desktop/VoltXAmpere/src/components/
 * definitions.js:96` `vac` — leads from the body edge (y=±18)
 * to the pin (y=±40) at 80-px sprite scale; ported to 40×26
 * viewBox as 3-px stubs.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT } from "./constants.js";
export const acSource = {
    id: "ac-source",
    nameTr: "AC Kaynak",
    nameEn: "AC Source",
    shortcut: "A",
    category: "source",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 20, y: 3, label: "out", polarity: "out" },
        { x: 20, y: 23, label: "gnd", polarity: "in" },
    ],
    defaultLabel: "V",
    defaultValue: "5Vac",
    renderSVG: () => [
        // Sprint 25 R3 lane 1 — pin lead lines (viewBox edge → pin).
        `<line x1="20" y1="0" x2="20" y2="3" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="20" y1="23" x2="20" y2="26" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        // Body circle.
        `<circle cx="20" cy="13" r="10" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        // Sine half-period inside the circle (two quadratic Beziers).
        `<path d="M 13 13 Q 16 6, 20 13 Q 24 20, 27 13" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
    ].join(""),
};
//# sourceMappingURL=ac-source.js.map